<template>
  <div class="h-toolbarBg">
    <ejs-toolbar>
      <e-items>
        <e-item v-if='btns.refresh' prefixIcon='icon hero-icon hero-icon-refresh' :tooltipText='$t("Common.refresh")' :click='buttonClk' operate='refresh'></e-item>
        <e-item v-if='btns.activate' prefixIcon='icon hero-icon hero-icon-start-up' :tooltipText='$t("NSMF.activate")' :click='buttonClk' operate='activate'></e-item>
        <e-item v-if='btns.deactivate' prefixIcon='icon hero-icon hero-icon-disable' :tooltipText='$t("NSMF.deactivate")' :click='buttonClk' operate='deactivate'></e-item>
        <e-item v-if='btns.delete' prefixIcon='icon hero-icon hero-icon-remove' :tooltipText='$t("NSMF.delete")' :click='buttonClk' operate='delete'></e-item>
        <e-item v-if='btns.monitor' prefixIcon='icon hero-icon hero-icon-statistics' :tooltipText='$t("NSMF.monitor")' :click='buttonClk' operate='monitor'></e-item>
      </e-items>
    </ejs-toolbar>
  </div>
</template>

<script>
export default {
  name: 'nsiMenu',
  data() {
    return {
      btns: {
        refresh: true,
        activate: true,        
        deactivate: true,      
        delete: true,    
        monitor: true,  
      },
    };
  },
  mounted() {
  },
  methods: {
    buttonClk(args) {
      this.$emit('methodEnum', args.item.operate);
    },
  },
};
</script>
